// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_32pq_","button":"view-header_button_1JOOW","active":"view-header_active_1xr_a","btnExport":"view-header_btnExport_2zVqw","mr":"view-header_mr_1M6R_"};